import { DepotView } from "@features/stock/components/DepotView";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/depots/$id/view")({
  loader: requirePermission(PERMISSIONS.STOCK.DEPOTS.VIEW),
  component: ViewDepotComponent,
});

function ViewDepotComponent() {
  const { id } = Route.useParams();

  return <DepotView id={Number(id)} />;
}
